import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../config/react'
import DataTable from 'react-data-table-component'

const Coupons = () => {
  const [CouponList, setCouponList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')
  const columns = [
    {
      name: 'Name',
      sortable: true,
      sortField: 'coupon_code',
      selector: (row) => row.coupon_code
    },
    {
      name: 'Expire Date',
      selector: (row) => <DateFormat value={row.expire_date}></DateFormat>
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/coupons/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteCoupon(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Coupons
    GetCouponList()
  }, [CustomFilters, SearchTerm])

  const GetCouponList = () => {
    const couponData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    // HttpService.postApi(API.GetCouponList, couponData)
    HttpService.postApi(API.GetCouponAdminList, couponData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setCouponList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_coupon)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search for Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteCoupon = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteCoupon, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetCouponList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  const handleExportExcel = () => {
    HttpService.postApi(API.GetCouponExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Coupons')
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Coupons} </h3>
        <div className="btn-group">
          <Link
            to="/coupons/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Coupon{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  // title="Coupons"
                  columns={columns}
                  data={CouponList}
                  // progressPending={loading}
                  pagination
                  paginationDefaultPage={currentPage}
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Coupons
